<template>
    <div>Table: {{ id }}</div>
</template>
<script>
export default {
    name: 'Table',
    props: {
        id: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
div {
    height: 300px;
    width: 100%;
    background-color: #dddddd;
    color: #bbb;
}
</style>
